import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import { ItemMetadata } from 'tripPlanner/models'
import type { ItemType } from 'tripPlanner/types/tripItem'

interface Props {
  itemType: ItemType
}

const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.default.five};
  width: 100%;
  height: ${rem(100)};
  overflow: hidden;
`

function PlaceholderImage({ itemType }: Props) {
  const Icon = ItemMetadata[itemType].icon
  return (
    <Placeholder>
      <Icon size={30} colour="neutral-four" />
    </Placeholder>
  )
}

export default PlaceholderImage
